import { render } from "./CreateLlmSkillSet.vue?vue&type=template&id=6fb28856"
import script from "./CreateLlmSkillSet.vue?vue&type=script&lang=js"
export * from "./CreateLlmSkillSet.vue?vue&type=script&lang=js"

import "./CreateLlmSkillSet.vue?vue&type=style&index=0&id=6fb28856&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__